
import logger from "@/lib/logger";
import { toast } from "@/hooks/use-toast";
import { checkInternetConnection } from "@/lib/network-utils";

export const performConnectivityCheck = async (): Promise<boolean> => {
  logger.log("Starting enhanced connectivity check sequence");
  
  // Show initial toast
  toast({
    title: "Checking connection...",
    description: "Verifying your internet connection.",
    duration: 2000,
  });
  
  // Try multiple connection checks with increasing timeouts
  let isConnected = false;
  
  try {
    // Try short timeout first (2s)
    logger.log("Attempting connectivity check with 2s timeout");
    isConnected = await checkInternetConnection(2000);
    
    if (!isConnected) {
      // Try medium timeout (4s)
      logger.log("First check failed, trying with 4s timeout");
      isConnected = await checkInternetConnection(4000);
      
      if (!isConnected) {
        // Try long timeout (6s) as last resort
        logger.log("Second check failed, trying with 6s timeout");
        isConnected = await checkInternetConnection(6000);
      }
    }
    
    if (!isConnected) {
      logger.error("All connectivity checks failed - offline detected");
      toast({
        title: "Connection Problem",
        description: "We couldn't connect to the internet. Please check your connection and try again.",
        variant: "destructive",
      });
    } else {
      logger.log("Connectivity confirmed after checks");
    }
    
    return isConnected;
  } catch (error) {
    logger.error("Error during connectivity check:", error);
    return false;
  }
};
